<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import rcsInboxes from 'dashboard/api/rcsInboxes';
import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';

// Caixa RCS: uma por conta, sem credenciais — a chave fica na instalação.
const { t } = useI18n();
const router = useRouter();
const store = useStore();

const name = ref('RCS');
const creating = ref(false);
const errorMessage = ref('');

// Códigos do backend viram texto traduzido; o resto mostra a mensagem crua.
const errorFrom = error => {
  const data = error?.response?.data || {};
  if (data.code === 'rcs_unavailable')
    return t('INBOX_MGMT.ADD.RCS.UNAVAILABLE');
  if (data.code === 'rcs_inbox_exists') {
    return t('INBOX_MGMT.ADD.RCS.ALREADY_EXISTS');
  }
  return data.error || data.message || t('INBOX_MGMT.ADD.RCS.ERROR');
};

const createInbox = async () => {
  creating.value = true;
  errorMessage.value = '';
  try {
    const { data } = await rcsInboxes.create({ name: name.value.trim() });
    await store.dispatch('inboxes/get');
    router.replace({
      name: 'settings_inboxes_add_agents',
      params: { page: 'new', inbox_id: data.inbox_id },
    });
  } catch (error) {
    errorMessage.value = errorFrom(error);
  } finally {
    creating.value = false;
  }
};
</script>

<template>
  <div class="w-full h-full col-span-6 p-6 overflow-auto">
    <h2 class="text-lg font-medium text-n-slate-12">
      {{ t('INBOX_MGMT.ADD.RCS.TITLE') }}
    </h2>
    <p class="mt-1 text-sm text-n-slate-11">
      {{ t('INBOX_MGMT.ADD.RCS.DESC') }}
    </p>
    <p class="mt-2 text-xs text-n-slate-10">
      {{ t('INBOX_MGMT.ADD.RCS.HINT') }}
    </p>
    <form
      class="flex flex-col gap-4 mt-6 max-w-md"
      @submit.prevent="createInbox"
    >
      <Input
        v-model="name"
        :label="t('INBOX_MGMT.ADD.RCS.NAME_LABEL')"
        :placeholder="t('INBOX_MGMT.ADD.RCS.NAME_PLACEHOLDER')"
      />
      <p
        v-if="errorMessage"
        data-test="rcs-error"
        class="text-sm text-n-ruby-11"
      >
        {{ errorMessage }}
      </p>
      <div>
        <Button
          type="submit"
          :label="t('INBOX_MGMT.ADD.RCS.CREATE')"
          :is-loading="creating"
          :disabled="!name.trim()"
        />
      </div>
    </form>
  </div>
</template>
